import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import {
  Sidebar,
  TopNavigation,
  AIAssistant,
  Dashboard,
  Patients,
  Schedule,
  Messages,
  PracticeManagement,
  Settings
} from './components';
import ContextMenuDemo from './components/demos/ContextMenuDemo';
import { appointments, messages as mockMessages, patients } from './data/mockDatabase';
import { AppProvider } from './providers/AppProvider';

function App() {
  const [isAIOpen, setIsAIOpen] = useState(false);
  const [displayAJReminder] = useState(true);
  
  const toggleChat = () => {
    setIsAIOpen(prev => !prev);
  };

  useEffect(() => {
    const handleToggleAIChat = () => {
      setIsAIOpen(prev => !prev);
    };

    const handleKeyDown = (e) => {
      // Check for Cmd+J (on Mac) or Ctrl+J (on Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key === 'j') {
        e.preventDefault(); // Prevent default browser behavior
        setIsAIOpen(prev => !prev);
      }
    };

    window.addEventListener('toggleAIChat', handleToggleAIChat);
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('toggleAIChat', handleToggleAIChat);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <AppProvider>
      <Router>
        <div className="app-layout">
          <TopNavigation
            toggleChat={toggleChat}
            isAIOpen={isAIOpen}
            displayAJReminder={displayAJReminder}
          />
          
          <div className="app-main">
            <Sidebar />
            
            <main className={`content ${isAIOpen ? 'ai-open' : ''}`}>
              <Routes>
                <Route 
                  path="/" 
                  element={
                    <Dashboard
                      appointments={appointments}
                      isAIOpen={isAIOpen}
                      toggleAI={toggleChat}
                      displayAJReminder={displayAJReminder}
                    />
                  } 
                />
                <Route path="/patients" element={<Patients patients={patients} />} />
                <Route path="/schedule" element={<Schedule appointments={appointments} />} />
                <Route path="/messages" element={<Messages messages={mockMessages} />} />
                <Route path="/practice-management" element={<PracticeManagement />} />
                <Route path="/settings" element={<Settings />} />
                <Route 
                  path="/context-menu-demo" 
                  element={
                    <>
                      {console.log('Rendering ContextMenuDemo')}
                      <ContextMenuDemo />
                    </>
                  } 
                />
              </Routes>
            </main>

            {isAIOpen && (
              <AIAssistant 
                isOpen={isAIOpen} 
                toggleChat={toggleChat} 
              />
            )}
          </div>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;